import React, { useEffect } from 'react';
import { SignUp, useUser, SignedIn, SignedOut } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';

// This component renders the sign-up page using Clerk's SignUp component.
function SignUpPage() {
  const navigate = useNavigate();
  const { isSignedIn } = useUser();

  useEffect(() => {
    if (isSignedIn) {
      navigate('/');
    }
  }, [isSignedIn, navigate]);

  return (
    <>
      <SignedIn>
        <div>Redirecting...</div>
      </SignedIn>
      <SignedOut>
        <div className="sign-in-up">
          <SignUp />
        </div>
      </SignedOut>
    </>
  );
}

export default SignUpPage;